import React from 'react';
import styles from './LineAnimationTwo.module.css'; // Import the CSS module

const LineAnimationTwo = () => {
    return (
        <div className={styles.animationContainer}>
            <div className={`${styles.line} ${styles.line1}`}></div>
            <div className={`${styles.line} ${styles.line2}`}></div>
            <div className={`${styles.line} ${styles.line3}`}></div>
            <div className={`${styles.line} ${styles.line4}`}></div>
            <div className={`${styles.line} ${styles.line5}`}></div>
            
            <div className={`${styles.line} ${styles.line6}`}></div>
            
            <div className={`${styles.line} ${styles.line7}`}></div>
        </div>
    );
};

export default LineAnimationTwo;
